import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import Button from 'elements/Buttons/Button';
import LinkAction from 'elements/Link/LinkAction/LinkAction';

import styles from './ButtonGroup.css';

const ButtonGroup = ({ small, left, right, modalsException }) => {
  const isLink = left.href !== undefined;
  const cx = classnames.bind(styles);

  const classes = cx(styles.actions, {
    'modalsException': modalsException,
    'small': small
  });

  left = {
    ...left,
    size: isLink && small ? 'm' : 'l',
    classes: !isLink && small ? 'small secondary' : 'secondary'
  };

  right = {
    ...right,
    classes: small ? 'small' : ''
  };

  return (
    <div className={classes}>
      {
        left.href
          ? <LinkAction {...left}>{left.children}</LinkAction>
          : <Button {...left}>{left.children}</Button>
      }
      <Button {...right}>{right.children}</Button>
    </div>
  );
};

ButtonGroup.displayName = 'ButtonGroup';
ButtonGroup.propTypes = {
  modalsException: PropTypes.bool,
  small: PropTypes.bool,
  left: PropTypes.object,
  right: PropTypes.object
};

export default ButtonGroup;



// WEBPACK FOOTER //
// ./src/uis/elements/Buttons/ButtonGroup.js